import React from "react";
import { Text, View } from "@react-pdf/renderer";

const ProluxHeatExchanger = ({
  summerRecCalculation,
  winterRecCalculation,
}) => {
  /*AUL (Außenluft): This stands for "outside air" or "fresh air" that is drawn into the AHU from the external environment.
ZUL (Zuluft): This stands for "supply air" or "incoming air" that is supplied to the conditioned space after being treated by the AHU.
FOL (Fortluft): This stands for "exhaust air" or "discharge air" that is expelled to the outside environment after being extracted from the conditioned space.
ABL (Abluft): This stands for "extract air" or "return air" that is extracted from the conditioned space and returned to the AHU for heat exchange.
REKUPERATOR */
  return (
    <View style={{ pageBreakAfter: "always", pageIbreakInside: "avoid" }}>
      <View
        style={{
          border: "2px solid black",
          fontSize: "8px",
          marginTop: "10px",
          paddingHorizontal: "5px",
        }}
      >
        <View style={{ display: "flex", flexDirection: "row" }}>
          <View style={{ width: "2%", alignSelf: "center" }}>
            <Text>1</Text>
          </View>
          <View
            style={{
              width: "96%",
              borderLeft: "1px solid black",
              borderRight: "1px solid black",
            }}
          >
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "center",
              }}
            >
              <View
                style={{
                  paddingLeft: "2px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Text style={{ fontSize: "10px", fontWeight: "600" }}>
                  <b>Wärmetauscher</b>
                </Text>
              </View>
            </View>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "center",
                borderTop: "1px solid black",
              }}
            >
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "25%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Wärmetauscher Fabrikat</Text>
                <Text>Prolux</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "25%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Typ</Text>
                <Text>Enthalpie/Gegenstrom/Rotation!!!!!</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "25%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Bypass mit Klappe</Text>
                <Text>inkl.</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "25%",
                  // flex: "1",
                }}
              >
                <Text style={{ color: "white" }}>-</Text>
                <Text style={{ color: "white" }}>-</Text>
              </View>
            </View>
          </View>
          <View style={{ width: "2%", paddingLeft: "2px" }}>
            <Text></Text>
          </View>
        </View>

        <View style={{ display: "flex", flexDirection: "row" }}>
          <View style={{ width: "2%", alignSelf: "center" }}>
            <Text></Text>
          </View>
          <View
            style={{
              width: "96%",
              borderLeft: "1px solid black",
              borderRight: "1px solid black",
            }}
          >
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "center",
                borderTop: "1px solid black",
              }}
            >
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  fontSize: "10px",
                  fontWeight: "bold",
                  // flex: "1",
                }}
              >
                <Text>Winter</Text>
              </View>
            </View>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "center",
                borderTop: "1px solid black",
              }}
            >
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Winter Luftvolumenstrom ZUL</Text>
                <Text>{winterRecCalculation.sup_AirVolumeFlow} m³/h</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Winter Eintritt Temperatur AUL</Text>
                <Text>{winterRecCalculation.sup_AirTempIn} °C</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Winter Eintritt Feuchte {"       "} AUL</Text>
                <Text>{winterRecCalculation.sup_HumidityIn} %</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Winter Austritt Temperatur ZUL</Text>
                <Text>{winterRecCalculation.sup_AirTempOut} °C</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  // flex: "1",
                }}
              >
                <Text>Winter Austritt Feuchte {"       "}ZUL</Text>
                <Text>{winterRecCalculation.sup_HumidityOut} %</Text>
              </View>
            </View>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "center",
                borderTop: "1px solid black",
              }}
            >
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Winter Luftvolumenstrom ABL</Text>
                <Text>{winterRecCalculation.eha_AirVolumeFlow} m³/h</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Winter Eintritt Temperatur ABL</Text>
                <Text>{winterRecCalculation.eha_AirTempIn} °C</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Winter Eintritt Feuchte {"                  "} ABL</Text>
                <Text>{winterRecCalculation.eha_HumidityIn} %</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Winter Austritt Temperatur FOL</Text>
                <Text>{winterRecCalculation.eha_HumidityIn} °C</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",

                  // flex: "1",
                }}
              >
                <Text>Winter Austritt Feuchte {"     "} FOL</Text>
                <Text>{winterRecCalculation.eha_HumidityOut} %</Text>
              </View>
            </View>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "center",
                borderTop: "1px solid black",
              }}
            >
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "25%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Winter Rückgewinn {"                            "}</Text>
                <Text>{winterRecCalculation.sup_TotalHeat} kW????</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "25%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Winter Rückwärmzahl feucht {"     "}</Text>
                <Text>{winterRecCalculation.moistureRecovery} g/kg????</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "25%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Winter Rückwärmzahl trocken</Text>
                <Text>/</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "25%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text style={{ color: "white" }}>/</Text>
                <Text style={{ color: "white" }}>/</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "25%",
                  //   borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text style={{ color: "white" }}>/</Text>
                <Text style={{ color: "white" }}>/</Text>
              </View>
            </View>
          </View>
          <View style={{ width: "2%", paddingLeft: "2px" }}>
            <Text></Text>
          </View>
        </View>
        <View style={{ display: "flex", flexDirection: "row" }}>
          <View style={{ width: "2%", alignSelf: "center" }}>
            <Text></Text>
          </View>
          <View
            style={{
              width: "96%",
              borderLeft: "1px solid black",
              borderRight: "1px solid black",
            }}
          >
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "center",
                borderTop: "1px solid black",
              }}
            >
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  fontSize: "10px",
                  fontWeight: "bold",
                  // flex: "1",
                }}
              >
                <Text>Sommer</Text>
              </View>
            </View>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "center",
                borderTop: "1px solid black",
              }}
            >
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Sommer Luftvolumenstrom ZUL</Text>
                <Text>{summerRecCalculation.sup_AirVolumeFlow} m³/h</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Sommer Eintritt Temperatur AUL</Text>
                <Text>{summerRecCalculation.sup_AirTempIn} °C</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Sommer Eintritt Feuchte {"       "} AUL</Text>
                <Text>{summerRecCalculation.sup_HumidityIn} %</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Sommer Austritt Temperatur ZUL</Text>
                <Text>{summerRecCalculation.sup_AirTempOut} °C</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  // flex: "1",
                }}
              >
                <Text>Sommer Austritt Feuchte {"       "}ZUL</Text>
                <Text>{summerRecCalculation.sup_HumidityOut} %</Text>
              </View>
            </View>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "center",
                borderTop: "1px solid black",
              }}
            >
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Sommer Luftvolumenstrom ABL</Text>
                <Text>{summerRecCalculation.eha_AirVolumeFlow} m³/h</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Sommer Eintritt Temperatur ABL</Text>
                <Text>{summerRecCalculation.eha_AirTempIn} °C</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Sommer Eintritt feucht {"                  "} ABL</Text>
                <Text>{summerRecCalculation.eha_HumidityIn} %</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",
                  borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Sommer Austritt Temperatur FOL</Text>
                <Text>{summerRecCalculation.eha_AirTempOut} °C</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "20%",

                  // flex: "1",
                }}
              >
                <Text>Sommer Austritt Feuchte {"     "} FOL</Text>
                <Text>{summerRecCalculation.eha_HumidityOut} %</Text>
              </View>
            </View>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                textAlign: "center",
                borderTop: "1px solid black",
              }}
            >
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "25%",
                  borderRight: "1px solid black",
                  // borderBottom: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Sommer Rückgewinn {"                            "}</Text>
                <Text>{summerRecCalculation.sup_TotalHeat} kW???</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "25%",
                  borderRight: "1px solid black",
                  // borderBottom: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Sommer Rückwärmzahl feucht {"     "}</Text>
                <Text>{summerRecCalculation.moistureRecovery} g/kg ???</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "25%",
                  borderRight: "1px solid black",
                  // borderBottom: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text>Sommer Rückwärmzahl trocken</Text>
                <Text>/</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "25%",
                  borderRight: "1px solid black",
                  // borderBottom: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text style={{ color: "white" }}>/</Text>
                <Text style={{ color: "white" }}>/</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "25%",
                  // borderBottom: "1px solid black",
                  //   borderRight: "1px solid black",
                  // flex: "1",
                }}
              >
                <Text style={{ color: "white" }}>/</Text>
                <Text style={{ color: "white" }}>/</Text>
              </View>
            </View>
          </View>
          <View style={{ width: "2%", paddingLeft: "2px" }}>
            <Text></Text>
          </View>
        </View>

        <View style={{ display: "flex", flexDirection: "row" }}>
          <View style={{ width: "2%", alignSelf: "center" }}>
            <Text></Text>
          </View>
          <View
            style={{
              width: "96%",
              borderLeft: "1px solid black",
              borderRight: "1px solid black",
            }}
          >
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                borderTop: "1px solid black",
              }}
            >
              <View
                style={{
                  width: "100%",
                  paddingLeft: "2px",
                  // flex: "1",
                }}
              >
                <Text style={{ fontSize: "10px", fontWeight: "bold" }}>
                  Bemerkung:
                </Text>
                <Text>- Rückwärmzahl nach XYZ :</Text>
                <Text>- Eisbildungsgrenze - 7°C</Text>
                <Text>- Einfrierschutz Zulufttemperatur 7.9 °C</Text>
                <Text style={{ color: "white" }}>-</Text>
                <Text>- inkl. innenliegende Adapter für Stellantrieb</Text>
              </View>
            </View>
          </View>
          <View style={{ width: "2%", paddingLeft: "2px" }}>
            <Text></Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default ProluxHeatExchanger;

//<View style={{ width: "2%", alignSelf: "center" }}>
